import axios from "axios";
import Cookies from "js-cookie";

// export const apiUrl = "https://live-api.foodoor.in/";
export const apiUrl =
  process.env.REACT_APP_API_URL || "https://foodoor-django.codescap.com/";

export const getAccessToken = () => Cookies.get("DBtoken");

// Attach token dynamically to all outgoing axios requests if present
axios.interceptors.request.use(
  (config) => {
    const token = Cookies.get("DBtoken");
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization && !config.headers.authorization) {
        config.headers.Authorization = token;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

